var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsdt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C23.2839 0 30 6.7161 30 15C30 23.2839 23.2836 30 15 30C6.7164 30 0 23.2857 0 15C0 6.7143 6.7152 0 15 0Z",
    fill: "#343434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8513 13.0014V10.77H21.954V7.37012H8.05918V10.77H13.1625V12.9996C9.01498 13.1901 5.89648 14.0115 5.89648 14.9955C5.89648 15.9795 9.01648 16.8009 13.1625 16.9926V24.1401H16.8525V16.992C20.9925 16.8009 24.1047 15.9801 24.1047 14.997C24.1047 14.0139 20.9925 13.1931 16.8525 13.002L16.8513 13.0014ZM16.8525 16.3866V16.3848C16.7484 16.3914 16.2135 16.4235 15.0225 16.4235C14.0703 16.4235 13.4004 16.3965 13.1643 16.3842V16.3872C9.50008 16.2249 6.76498 15.5868 6.76498 14.8233C6.76498 14.0598 9.50038 13.4226 13.1643 13.26V15.7515C13.4043 15.768 14.0907 15.8085 15.0381 15.8085C16.176 15.8085 16.7481 15.7611 16.8531 15.7515V13.26C20.5101 13.4229 23.2389 14.0616 23.2389 14.8224C23.2389 15.5832 20.5089 16.2222 16.8531 16.3851",
    fill: "#5B5B5B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.68b7443d96b9ebbe842b8f9b9ae6c7ee.svg";
export { ForwardRef as ReactComponent };